
import React from 'react';
import { Textarea } from '@/components/ui/textarea';
import { Button } from '@/components/ui/button';
import { Save, Clock, Check } from 'lucide-react';
import { CardFooter } from '@/components/ui/card';

interface ReflectionFormProps {
  reflectionText: string;
  setReflectionText: (text: string) => void;
  submitReflection: () => Promise<void>;
  isSubmitting: boolean;
  existingReflection: string | null;
  setShowForm: (show: boolean) => void;
}

const ReflectionForm: React.FC<ReflectionFormProps> = ({
  reflectionText,
  setReflectionText,
  submitReflection,
  isSubmitting,
  existingReflection,
  setShowForm,
}) => {
  return (
    <>
      <Textarea 
        value={reflectionText}
        onChange={(e) => setReflectionText(e.target.value)}
        placeholder="Type your reflection here..."
        rows={6}
      />
      <CardFooter className="justify-between mt-4">
        {existingReflection && (
          <Button 
            variant="outline" 
            onClick={() => {
              setShowForm(false);
              setReflectionText(existingReflection);
            }}
          >
            Cancel
          </Button>
        )}
        <Button 
          onClick={submitReflection}
          disabled={isSubmitting || !reflectionText.trim()}
          className="ml-auto"
        >
          {isSubmitting ? (
            <>
              <Clock className="mr-2 h-4 w-4 animate-spin" />
              Submitting
            </>
          ) : existingReflection ? (
            <>
              <Save className="mr-2 h-4 w-4" />
              Update Reflection
            </>
          ) : (
            <>
              <Check className="mr-2 h-4 w-4" />
              Submit Reflection
            </>
          )}
        </Button>
      </CardFooter>
    </>
  );
};

export default ReflectionForm;
